// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__KVcg5","errorPageText":"ErrorPage_errorPageText__fOByU"};